import React from 'react'
import Navbar from '../containers/Navbar/Navbar.container'
import ManagementMenu from '../containers/ManagementMenu/ManagementMenu.container'
import routes from '../config/settings/routes'
import ProtectBySession from '../components/Security/ProtectBySession'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import { LassoPolygon, MapBoundary } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem, Stack } from '@carbon/react'
import { Iframe } from '../containers/Map/Map.styles'
import { CardComponent } from '../components/Layouts/Card.styles'
import Card from '../components/Layouts/Card';
import Typography from '../components/Basics/Typography'
import InformationContainer from '../components/Basics/Information.container'
import KeplerMapContainer from '../containers/Kepler/Kepler.container'

/**
 * The Map's Page.
 */
const Kepler = () => {
  const KeplerBreadCrumbs = () => {
    return (
      <Breadcrumb noTrailingSlash>
        <BreadcrumbItem>
          <a href="/#">UCO</a>
        </BreadcrumbItem>
        <BreadcrumbItem href="#" isCurrentPage>Mapa de Ciclos</BreadcrumbItem>
      </Breadcrumb>
    )
  }

  const title = 'Mapa de Ciclos'

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <BrandLayout
        navbar={<Navbar managementMenu={<ManagementMenu current={routes.kepler} />} />}
        header={<Heading title={title} icon={<LassoPolygon size={50} />} breadcrumbs={<KeplerBreadCrumbs />} tooltipContent='Vista para visualizar puntos utilizando kepler.'/>}
      >
        <Stack gap={3}>
        <KeplerMapContainer />

        </Stack>
      </BrandLayout>
    </ProtectBySession>
  )
}

export default Kepler
